export default __webpack_public_path__ + "static/media/planarshift.bf47c2cb.png";